import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import { CHART_DIMENSIONS } from "./config/chart-config";
import { CustomLegend } from "./custom-legend";
import { CustomTooltip } from "./custom-tooltip";
import { ChartWrapper } from "./chart-wrapper";
import { useChartTheme } from "./hooks/useChartTheme";
import type { FC } from "react";

export type OrganizationStatus =
  | "NEW"
  | "ONBOARDING"
  | "GESTATING"
  | "LIVE"
  | "DEAD"
  | "TEST";

interface StatusDistribution {
  readonly name: string;
  readonly value: number;
  readonly percentage: number;
}

interface StatusDistributionChartProps {
  readonly data: readonly StatusDistribution[];
}

/**
 * Displays the distribution of organization statuses using a pie chart
 */
export const StatusDistributionChart: FC<StatusDistributionChartProps> = ({
  data,
}) => {
  const { statusColors, chartProps } = useChartTheme();

  return (
    <ChartWrapper>
      <PieChart>
        <Pie
          data={[...data]}
          cx="50%"
          cy="50%"
          innerRadius={CHART_DIMENSIONS.pieChart.innerRadius}
          outerRadius={CHART_DIMENSIONS.pieChart.outerRadius}
          paddingAngle={CHART_DIMENSIONS.pieChart.paddingAngle}
          dataKey="value"
        >
          {[...data].map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={statusColors[entry.name as OrganizationStatus]}
            />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} {...chartProps.tooltip} />
        <Legend content={<CustomLegend />} {...chartProps.legend} />
      </PieChart>
    </ChartWrapper>
  );
};
